import React, { useEffect, useState } from 'react'
import { Box, FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core'
import useStyles from './styles'

const UNIT_OPTIONS = [
  { label: 'Seconds', value: 'seconds', factor: 1 },
  { label: 'Minutes', value: 'minutes', factor: 60 },
  { label: 'Hours', value: 'hours', factor: 3600 },
  { label: 'Days', value: 'days', factor: 86400 },
]

export const WaitingTimeoutInput = ({ value, onChange, disabled, useLabel, label, inputLabelProps }) => {
  const classes = useStyles()
  const totalSeconds = Number(value) || 0
  const [unit, setUnit] = useState('seconds')
  const [amount, setAmount] = useState(0)

  useEffect(() => {
    const isValidNumber = Number.isFinite(totalSeconds)
    if (!isValidNumber) {
      setUnit('seconds')
      setAmount(0)
      return
    }

    const secondsUnit = UNIT_OPTIONS.find(u => u.value === 'seconds') || UNIT_OPTIONS[0]
    const minutesUnit = UNIT_OPTIONS.find(u => u.value === 'minutes')
    const hoursUnit = UNIT_OPTIONS.find(u => u.value === 'hours')
    const daysUnit = UNIT_OPTIONS.find(u => u.value === 'days')

    let bestUnit = secondsUnit
    if (totalSeconds > 0) {
      if (daysUnit && totalSeconds % daysUnit.factor === 0) {
        bestUnit = daysUnit
      } else if (hoursUnit && totalSeconds % hoursUnit.factor === 0) {
        bestUnit = hoursUnit
      } else if (minutesUnit && totalSeconds >= 120 && totalSeconds % minutesUnit.factor === 0) {
        bestUnit = minutesUnit
      }
    }

    const nextUnit = bestUnit.value
    if (unit !== nextUnit) {
      setUnit(nextUnit)
    }

    const nextAmount = totalSeconds / bestUnit.factor
    setAmount(Number.isFinite(nextAmount) ? nextAmount : 0)
  }, [value, unit])

  const emitChange = (nextAmount, nextUnit) => {
    const selectedUnit = UNIT_OPTIONS.find(u => u.value === nextUnit) || UNIT_OPTIONS[0]
    const seconds = (Number(nextAmount) || 0) * selectedUnit.factor
    onChange && onChange(seconds)
  }

  const handleAmountChange = (e) => {
    const nextAmount = e.target.value
    setAmount(nextAmount)
    emitChange(nextAmount, unit)
  }

  const handleUnitChange = (e) => {
    const nextUnit = e.target.value
    setUnit(nextUnit)
    emitChange(amount, nextUnit)
  }

  return (
    <Box display="flex" alignItems="center" style={{ marginTop: useLabel ? '1.2rem' : 0, gap: '10px' }}>
      <TextField
        type="number"
        value={amount}
        onChange={handleAmountChange}
        inputProps={{ min: 0 }}
        style={{ width: 160 }}
        disabled={disabled}
        label={label}
        InputLabelProps={inputLabelProps}
      />
      <FormControl style={{ minWidth: 140 }}>
        <InputLabel className={classes.textFieldInputLabel}></InputLabel>
        <Select
          value={unit}
          onChange={handleUnitChange}
          disabled={disabled}
        >
          {UNIT_OPTIONS.map(opt => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}

export default WaitingTimeoutInput
